import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getUser } from '../../utils/tokens';
import PDFPreviewPage from './ResourcePreview';

const getResourceURL = (resourceId, clientId) => `/resource/v1/resources/${resourceId}/clients/${clientId}`;

const ResourceAttachmentView = () => {
	const [resource, setResource] = useState(null);
	const [showPreview, setShowPreview] = useState(true);

	let { resourceId } = useParams();
	const currentUser = getUser();

	useEffect(() => {
		const fetchResource = async () => {
			const response = await axios({
				method: 'GET',
				url: getResourceURL(resourceId, currentUser.clientIdNum),
			});

			setResource(response.data);
		};

		if (resourceId) {
			fetchResource().catch(console.error);
		}
	}, [resourceId]);

	if (resourceId && !resource) {
		return <div></div>;
	}

	if (resource) {
		return (
			<div className="border-2 bg-white ml-4 rounded-lg">
				{showPreview && (
					<PDFPreviewPage
						attachmentId={resource.resourceAttachments[0].key.s3ResourceId}
						attachment={resource.resourceAttachments[0]}
						open={showPreview}
						setOpen={setShowPreview}
					/>
				)}
			</div>
		);
	}
};

export default ResourceAttachmentView;
